export default "__VITE_ASSET__DtVStZ$5__"